// extracted by mini-css-extract-plugin
module.exports = {"card":"IndustryCard_card___Pr6R","image":"IndustryCard_image__qKY2z","gradient":"IndustryCard_gradient__m7nlr","heading":"IndustryCard_heading__WkbVJ"};